import { EmblueLogo } from '@/src/assets';
import { urlWithPublicPath } from '@/src/presentation/util';

export const EmblueIcon = () => (
  <img
    alt="emblue logo"
    src={urlWithPublicPath(EmblueLogo as string)}
    style={{
      height: '32px',
      paddingRight: '12px',
    }}
  />
);
